import React, { useState } from 'react';
import { DeepMap, FieldError } from 'react-hook-form';
import { IntlString } from '@utils/formatter';
import CheckboxGroup from '../CheckboxGroup';
import { Props as CheckboxGroupPresenter } from '../CheckboxGroup/CheckboxGroupPresenter';
import {
  Typography,
  TextField,
  InputAdornment,
  IconButton
} from '@material-ui/core';
import { RemoveRedEye, VisibilityOff } from '@material-ui/icons';
import { useCardStyle } from './styles';
import useUserActionLog from '@hooks/useUserActionLog';

interface InputItemProps {
  name: string;
  className?: string;
  inputProps?: any;
  errors?: DeepMap<Record<string, any>, FieldError>;
  marginBottom?: number;
  multiline?: boolean;
  rows?: number | string;
  rowsMax?: number | string;
  fullWidth?: boolean;
  disabled?: boolean;
}

export const InputItem: React.FC<InputItemProps> = (props: InputItemProps) => {
  const { inputRoot } = useCardStyle();
  const [isVisibilityPassword, setIsVisibilityPassword] = useState(false);
  const error = props.errors && props.errors[props.name];
  const placeholder = IntlString(`join.placeholder.${props.name}`);
  const helperText =
    error && error.message
      ? error.message
      : IntlString(error ? `join.error.${props.name}` : '');
  const { insertButtonLog } = useUserActionLog();

  return (
    <TextField
      type={
        !isVisibilityPassword && props.name === 'password'
          ? 'password'
          : undefined
      }
      InputProps={
        props.name === 'password'
          ? {
              endAdornment: (
                <InputAdornment
                  className="remove-red-eye-icon"
                  position="end"
                  onClick={() => {
                    insertButtonLog('Button_Signup_Password_ShowPassword');
                    setIsVisibilityPassword((state) => !state);
                  }}
                >
                  <IconButton size="small" edge="end">
                    {isVisibilityPassword ? (
                      <RemoveRedEye />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              )
            }
          : {}
      }
      fullWidth={props.fullWidth || true}
      disabled={props.disabled}
      size="small"
      variant="outlined"
      name={props.name}
      className={props.className}
      classes={{ root: inputRoot }}
      inputProps={props.inputProps}
      placeholder={placeholder}
      error={error ? true : false}
      helperText={error && helperText}
      multiline={props.multiline}
      minRows={props.rows}
      maxRows={props.rowsMax}
    />
  );
};

interface CheckboxItemProps
  extends Pick<
    CheckboxGroupPresenter,
    'value' | 'options' | 'gridContainerProps'
  > {
  xs: any;
  name: string;
  onChange: (value: string[]) => void;
  errors?: DeepMap<Record<string, any>, FieldError>;
}

export const CheckboxItem = (props: CheckboxItemProps) => {
  const error = props.errors && props.errors[props.name];
  const helperText = IntlString(error ? `request.error.${props.name}` : '');

  return (
    <React.Fragment>
      <CheckboxGroup {...props} gridItemProps={{ xs: props.xs }} />
      {helperText && (
        <Typography color="error" variant="caption" style={{ marginTop: 12 }}>
          {helperText}
        </Typography>
      )}
    </React.Fragment>
  );
};
